/**
 * Allys Property Contact Card Component
 * 
 * Allys-themed wrapper for PropertyContactCard - clean, professional styling
 */

'use client';

import { PropertyContactCard, type PropertyContactCardProps } from '@/components/properties';

export function AllysPropertyContactCard(props: PropertyContactCardProps) {
  return (
    <div 
      className="relative font-inter"
    >
      <PropertyContactCard {...props} className="" />
    </div>
  );
}
